/**
* Generated by Kubb (https://kubb.dev/).
* Do not edit manually.
*/

import fetch from "../../../api-client";
import type { RequestConfig, ResponseErrorConfig } from "../../../api-client";
import type { LiveblocksControllerAuthMutationResponse, LiveblocksControllerAuth400, LiveblocksControllerAuth401, LiveblocksControllerAuth403, LiveblocksControllerAuth404 } from "../../models/liveblocksController/LiveblocksControllerAuth";

function getLiveblocksControllerAuthUrl() {
  const res = { method: 'POST', url: `/api/v1/liveblocks/auth` as const }  
  return res
}

/**
 * @summary Authenticate with Liveblocks
 * {@link /api/v1/liveblocks/auth}
 */
export async function liveblocksControllerAuth(config: Partial<RequestConfig> & { client?: typeof fetch } = {}) {
  const { client: request = fetch, ...requestConfig } = config  
  
  const res = await request<LiveblocksControllerAuthMutationResponse, ResponseErrorConfig<LiveblocksControllerAuth400 | LiveblocksControllerAuth401 | LiveblocksControllerAuth403 | LiveblocksControllerAuth404>, unknown>({ method : "POST", url : getLiveblocksControllerAuthUrl().url.toString(), ... requestConfig })  
  return res.data
}